export const noDataMessage = (type: "trendline" | "% change") =>
  `No ${type} is shown for this indicator because there are not enough data points.`;
